import {
  COMPLIANCE_LOADER,
  SET_COMPLIANCE_INITIAL_DATA,
  SET_COMPLIANCE_STATE_DATA,
  SET_PROCESSED_DATA,
  SET_SELECTED_SITE,
} from "./complianceConstants";

const initialState = {
    complianceLoader: false,
    complianceInitialData: null,
    stateList: [],
    tooltipMap: {},
    processedData: null,
    selectedSite: null,
    complianceStateData: {
      standardRules: []
    },
}

export const ComplianceReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPLIANCE_LOADER: {
      return {
        ...state,
        complianceLoader: action.payload.complianceLoader,
      };
    }
    case SET_SELECTED_SITE: {
      return {
        ...state,
        selectedSite: action.payload.selectedSite,
      };
    }
    case SET_COMPLIANCE_INITIAL_DATA: {
      return {
        ...state,
        stateList: action.payload.stateList,
        tooltipMap: action.payload.tooltipMap,
        complianceInitialData: action.payload.complianceInitialData,
      };
    }
    case SET_PROCESSED_DATA: {
      return {
        ...state,
        processedData: action.payload.processedData,
      };
    }
    case SET_COMPLIANCE_STATE_DATA: {
      return {
        ...state,
        complianceStateData: action.payload.complianceStateData,
      };
    }
    default:
      return state;
  }
}